import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../ApiSetup/Axios";
import {
  ApiDelete,
  ApiGet,
  ApiPost,
  ApiPostNoAuth,
  ApiPut,
} from "../../ApiSetup/Api";

export const login = createAsyncThunk("login", async (body) => {
  return ApiPostNoAuth(api?.login, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const verifyOtp = createAsyncThunk("verifyOtp", async (body) => {
  return ApiPostNoAuth(api?.verifyOtp, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// -----------------------------------  Layout  -----------------------------------
//get Available access
export const getAvailableAccess = createAsyncThunk(
  "getAvailableAccess",
  async (body) => {
    return ApiGet(api?.getAvailableAccess, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// -----------------------------------  Add Member  -----------------------------------

// upload Image
export const uploadImage = createAsyncThunk("uploadImage", async (body) => {
  return ApiPost(api?.uploadImage, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// delete File Image
export const deleteFile = createAsyncThunk("deleteFile", async (body) => {
  return ApiPost(api?.deleteFile, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// -----------------------------------  Add Member  -----------------------------------

// add Member
export const addMember = createAsyncThunk("addMember", async (body) => {
  return ApiPost(api?.addMember, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//getLocationByPincode
export const getLocationByPincode = createAsyncThunk(
  "getLocationByPincode",
  async (body) => {
    return ApiPost(api?.getLocationByPincode, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// get Member
export const getMember = createAsyncThunk("getMember", async (body) => {
  return ApiGet(api?.getMember + body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// update Member
export const updateMember = createAsyncThunk("updateMember", async (body) => {
  return ApiPut(api?.updateMember, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// -----------------------------------  settings / general  -----------------------------------
// getForm
export const getForm = createAsyncThunk("getForm", async (body) => {
  return ApiGet(api?.getForm, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// createFields
export const createFields = createAsyncThunk("createFields", async (body) => {
  return ApiPost(api?.createFields, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// deleteFields
export const deleteFields = createAsyncThunk("deleteFields", async (body) => {
  return ApiDelete(api?.deleteFields, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// getDataById
export const getDataById = createAsyncThunk("getDataById", async (body) => {
  return ApiPost(api?.getDataById, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// updateFields
export const updateFields = createAsyncThunk("updateFields", async (body) => {
  return ApiPut(api?.updateFields, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// -----------------------------------  settings / User & Role  -----------------------------------
//get role access
export const get_role_access = createAsyncThunk(
  "get_role_access",
  async (body) => {
    return ApiGet(api?.get_role_access, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

//get available access
export const get_available_access = createAsyncThunk(
  "get_available_access",
  async (body) => {
    return ApiGet(api?.get_available_access, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// add role access
export const add_role_access = createAsyncThunk(
  "add_role_access",
  async (body) => {
    return ApiPost(api?.add_role_access, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// update role access
export const update_role_access = createAsyncThunk(
  "update_role_access",
  async (body) => {
    return ApiPut(api?.update_role_access, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// get role access
export const get_dynamic_role_list = createAsyncThunk(
  "get_dynamic_role_list",
  async (body) => {
    return ApiGet(api?.get_dynamic_role_list, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// get_user_list
export const get_user_list = createAsyncThunk("get_user_list", async (body) => {
  return ApiPost(api?.get_user_list, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// inactive_user_list
export const inactive_user_list = createAsyncThunk(
  "inactive_user_list",
  async (body) => {
    return ApiPost(api?.inactive_user_list, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// add_extra_userType
export const add_extra_userType = createAsyncThunk(
  "add_extra_userType",
  async (body) => {
    return ApiPost(api?.add_extra_userType, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// active_inactive_member
export const active_inactive_member = createAsyncThunk(
  "active_inactive_member",
  async (body) => {
    return ApiPost(api?.active_inactive_member, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// add Role
export const addRole = createAsyncThunk("addRole", async (body) => {
  return ApiPost(api?.addRole, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// -----------------------------------  Stage Of Claims  -----------------------------------

//get Stage
export const getStage = createAsyncThunk("getStage", async (body) => {
  return ApiGet(api?.getStage, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//create Stage
export const addStage = createAsyncThunk("addStage", async (body) => {
  return ApiPost(api?.addStage, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//update Stage
export const updateStage = createAsyncThunk("updateStage", async (body) => {
  return ApiPut(api?.updateStage, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//delete Stage
export const deleteStage = createAsyncThunk("deleteStage", async (body) => {
  return ApiDelete(api?.deleteStage + body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// ----------------------------------- Setting >> FAQ  -----------------------------------

//get FAQ
export const getFaqs = createAsyncThunk("getFaqs", async (body) => {
  return ApiPost(api?.getFaqs, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//create FAQ
export const addFaqs = createAsyncThunk("addFaqs", async (body) => {
  return ApiPost(api?.addFaqs, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//update FAQ
export const updateFaqs = createAsyncThunk("updateFaqs", async (body) => {
  return ApiPut(api?.updateFaqs, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//delete FAQ
export const deleteFaqs = createAsyncThunk("deleteFaqs", async (body) => {
  return ApiDelete(api?.deleteFaqs + body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// ----------------------------------- Setting >> Account  -----------------------------------
//get Account
export const getAccount = createAsyncThunk("getAccount", async (body) => {
  return ApiPost(api?.getAccount, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//create Account
export const addAccount = createAsyncThunk("addAccount", async (body) => {
  return ApiPost(api?.addAccount, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//update Account
export const updateAccount = createAsyncThunk("updateAccount", async (body) => {
  return ApiPut(api?.updateAccount, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//delete Account
export const deleteAccount = createAsyncThunk("deleteAccount", async (body) => {
  return ApiDelete(api?.deleteAccount + body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// -----------------------------------  Documents  -----------------------------------

//get Documents

export const getDocuments = createAsyncThunk("getDocuments", async (body) => {
  return ApiPost(api?.getDocuments, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//verify Documets
export const verifyDocuments = createAsyncThunk(
  "verifyDocuments",
  async (body) => {
    return ApiPost(api?.verifyDocuments, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

//verify Documets
export const getDocumentsById = createAsyncThunk(
  "getDocumentsById",
  async (body) => {
    return ApiGet(api?.getDocumentsById + body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

//verify Documets
export const getMembersSummary = createAsyncThunk(
  "getMembersSummary",
  async (body) => {
    return ApiPost(api?.getMembersSummary, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// -----------------------------------  settings / Banner  -----------------------------------

//get Banner
export const getBanner = createAsyncThunk("getBanner", async (body) => {
  return ApiPost(api?.getBanner, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//add Banner
export const addBanner = createAsyncThunk("addBenner", async (body) => {
  return ApiPost(api?.addBanner, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//update Banner
export const updateBanner = createAsyncThunk("updateBanner", async (body) => {
  return ApiPut(api?.updateBanner, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//delete Banner
export const deleteBanner = createAsyncThunk("deleteBanner", async (body) => {
  return ApiDelete(api?.deleteBanner + body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// -----------------------------------  settings / General Notifications  -----------------------------------

//get Notifications
export const getNotifications = createAsyncThunk(
  "getNotifications",
  async (body) => {
    return ApiPost(api?.getNotifications, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

//add Notifications
export const addNotifications = createAsyncThunk(
  "addNotifications",
  async (body) => {
    return ApiPost(api?.addNotifications, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

//update Notifications
export const updateNotifications = createAsyncThunk(
  "updateNotifications",
  async (body) => {
    return ApiPost(api?.updateNotifications, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

//delete Notifications
export const deleteNotifications = createAsyncThunk(
  "deleteNotifications",
  async (body) => {
    return ApiDelete(api?.deleteNotifications + body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// -----------------------------------  settings / General Occupation  -----------------------------------

//get Notifications
export const getOccupation = createAsyncThunk("getOccupation", async (body) => {
  return ApiPost(api?.getOccupation, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//add Notifications
export const addOccupation = createAsyncThunk("addOccupation", async (body) => {
  return ApiPost(api?.addOccupation, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

//update Notifications
export const updateOccupation = createAsyncThunk(
  "updateOccupation",
  async (body) => {
    return ApiPut(api?.updateOccupation, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

//delete Notifications
export const deleteOccupation = createAsyncThunk(
  "deleteOccupation",
  async (body) => {
    return ApiDelete(api?.deleteOccupation + `/${body}`)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// -----------------------------------  settings / App Version -----------------------------------

// get App Version
export const getAppVersion = createAsyncThunk("getAppVersion", async (body) => {
  return ApiGet(api?.getAppVersion + body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// update App Version
export const updateAppVersion = createAsyncThunk(
  "updateAppVersion",
  async (body) => {
    return ApiPost(api?.updateAppVersion, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// -----------------------------------  settings / App Role & Permission -----------------------------------

// update App Role & Permission
export const update_application_role_permission = createAsyncThunk(
  "update_application_role_permission",
  async (body) => {
    return ApiPost(api?.update_application_role_permission, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// -----------------------------------  follwUp -----------------------------------
// get_all_followups
export const get_all_followups = createAsyncThunk(
  "get_all_followups",
  async (body) => {
    return ApiPost(api?.get_all_followups, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const getDocumentAssigneeRoles = createAsyncThunk(
  "getDocumentAssigneeRoles",
  async (body) => {
    return ApiGet(api?.getDocumentAssigneeRoles, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const assignMember = createAsyncThunk("assignMember", async (body) => {
  return ApiPost(api?.assignMember, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// update_followup
export const update_followup = createAsyncThunk(
  "update_followup",
  async (body) => {
    return ApiPost(api?.update_followup, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// -----------------------------------  get Transaction History -----------------------------------

// get Transaction History
export const getTransactionHistory = createAsyncThunk(
  "getTransactionHistory",
  async (body) => {
    return ApiPost(api?.getTransactionHistory, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const getParticularUserTransaction = createAsyncThunk(
  "getParticularUserTransaction",
  async (body) => {
    return ApiPost(api?.getParticularUserTransaction, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// ----------------------------------- Member Serach-----------------------------------

// getMember By Mobile Number
export const getMemberByMobileNumber = createAsyncThunk(
  "getMemberByMobileNumber",
  async (body) => {
    return ApiPost(api?.getMemberByMobileNumber, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

// Get Transaction List
export const get_transaction_list = createAsyncThunk(
  "get_transaction_list",
  async (body) => {
    return ApiPost(api?.get_transaction_list, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const app_get_role_access = createAsyncThunk(
  "app_get_role_access",
  async (body) => {
    return ApiGet(api?.app_get_role_access, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const app_update_role_access = createAsyncThunk(
  "app_update_role_access",
  async (body) => {
    return ApiPut(api?.app_update_role_access, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const active_inactive_member_Deactive = createAsyncThunk(
  "active_inactive_member_Deactive",
  async (body) => {
    return ApiPost(api?.active_inactive_member_Deactive, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const get_company_member_list = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.get_company_member_list, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const get_company_members_summary = createAsyncThunk(
  "get_company_members_summary",
  async (body) => {
    return ApiPost(api?.get_company_members_summary, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const update_company_member = createAsyncThunk("update_company_member", async (body) => {
  return ApiPost(api?.update_company_member, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const get_organisation_payment_request   = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.get_organisation_payment_request  , body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const approve_organisation_paymentRequest   = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.approve_organisation_paymentRequest, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const create_organisation_paymentRequest   = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.create_organisation_paymentRequest, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const add_user_transaction   = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.add_user_transaction, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const aadhar_send_otp   = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.aadhar_send_otp, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const aadhar_verify_otp   = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.aadhar_verify_otp, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const id_proof_verification   = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.id_proof_verification, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const get_payment_receipt   = createAsyncThunk(
  "get_company_member_list",
  async (body) => {
    return ApiPost(api?.get_payment_receipt, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);

export const api_config = createAsyncThunk("api_config", async () => {
  return ApiGet(api?.api_config)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const update_config   = createAsyncThunk(
  "update_config",
  async (body) => {
    return ApiPost(api?.update_config, body)
      .then((response) => response?.data)
      .catch((error) => error);
  }
);


// -----------------------------------  News & Banner  -----------------------------------

// //get Event
export const get_posts = createAsyncThunk("get_posts", async (body) => {
  return ApiPost(api?.get_posts, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// //add Event
export const create_posts = createAsyncThunk("create_posts", async (body) => {
  return ApiPost(api?.create_posts, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// //update Event
export const update_post = createAsyncThunk("update_post", async (body) => {
  return ApiPost(api?.update_post, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

// //delete Event
export const delete_post = createAsyncThunk("delete_post", async (body) => {
  return ApiPost(api?.delete_post, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const createPrivacyPolicyAndTermsAndCondition = createAsyncThunk("createPrivacyPolicyAndTermsAndCondition", async (body) => {
  return ApiPost(api?.createPrivacyPolicyAndTermsAndCondition, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const getPrivacyPolicyAndTermsAndCondition = createAsyncThunk("getPrivacyPolicyAndTermsAndCondition", async (body) => {
  return ApiPost(api?.getPrivacyPolicyAndTermsAndCondition, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const get_contactUs = createAsyncThunk("get_contactUs", async (body) => {
  return ApiPost(api?.get_contactUs, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const delete_contactUs = createAsyncThunk("delete_contactUs", async (body) => {
  return ApiPost(api?.delete_contactUs, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const updatePrivacyPolicyAndTermsAndCondition = createAsyncThunk("updatePrivacyPolicyAndTermsAndCondition", async (body) => {
  return ApiPost(api?.updatePrivacyPolicyAndTermsAndCondition, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const getMemberByPhoneNumber = createAsyncThunk("getMemberByPhoneNumber", async (body) => {
  return ApiPost(api?.getMemberByPhoneNumber, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const getTicket = createAsyncThunk("getTicket", async (body) => {
  return ApiPost(api?.getTicket, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const deleteTicket = createAsyncThunk("deleteTicket", async (body) => {
  return ApiPost(api?.deleteTicket, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const getAllEligibleMembers = createAsyncThunk("getAllEligibleMembers", async (body) => {
  return ApiPost(api?.getAllEligibleMembers, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const getAllClaims = createAsyncThunk("getAllClaims", async (body) => {
  return ApiPost(api?.getAllClaims, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const updateClaim = createAsyncThunk("updateClaim", async (body) => {
  return ApiPost(api?.updateClaim, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const createaboutUs = createAsyncThunk("createaboutUs", async (body) => {
  return ApiPost(api?.createaboutUs, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const updateaboutUs = createAsyncThunk("updateaboutUs", async (body, id) => {
  return ApiPost(`${api?.updateaboutUs}/${body?.id}`, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const getallaboutUs = createAsyncThunk("getallaboutUs", async (body) => {
  return ApiGet(api?.getallaboutUs, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const getallpressandmediacoverage = createAsyncThunk("getallpressandmediacoverage", async (body) => {
  return ApiGet(api?.getallpressandmediacoverage, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const createpressandmediacoverage = createAsyncThunk("createpressandmediacoverage", async (body) => {
  return ApiPost(api?.createpressandmediacoverage, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const updatepressandmediacoverage = createAsyncThunk("updatepressandmediacoverage", async (body, id) => {
  return ApiPost(`${api?.updatepressandmediacoverage}/${body?.id}`, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const getallpress = createAsyncThunk("getallpress", async (body) => {
  return ApiPost(api?.getallpress, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const createpress = createAsyncThunk("createpress", async (body) => {
  return ApiPost(api?.createpress, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const updatepress = createAsyncThunk("updatepress", async (body, id) => {
  return ApiPost(`${api?.updatepress}`, body)
    .then((response) => response?.data)
    .catch((error) => error);
});

export const deletepress = createAsyncThunk("deletepress", async (body) => {
  return ApiPost(api?.deletepress, body)
    .then((response) => response?.data)
    .catch((error) => error);
});